import { BaseTariffPage } from "@/components/tarif/BaseTariffPage";
import { Shield, Lock, Users, AlertTriangle, CheckCircle, FileText, Building2, Stethoscope, Hospital } from "lucide-react";

const SIGNAL_IDUNA_COLOR = "#005CA9";

const SignalIdunaTarif = () => {
  return (
    <BaseTariffPage
      companyName="Signal Iduna"
      companyColor={SIGNAL_IDUNA_COLOR}
      productRating={{ value: 4.6, count: 289 }}
      priceRange="55-200"
      pageTitle="Signal Iduna Cyberversicherung für Arztpraxen | Umfassender Cyberschutz"
      metaDescription="Signal Iduna Cyberversicherung - Professioneller Schutz für Arztpraxen, MVZ und Kliniken. Umfassende Absicherung gegen Cyberrisiken mit schneller Schadensregulierung."
      metaKeywords="Signal Iduna Cyberversicherung, Arztpraxis, MVZ, Klinik, Cyberschutz, Datenschutz, IT-Sicherheit"
      canonicalUrl="https://praxis-versichert.de/tarifwissen/signal-iduna"
      heroLabel="Signal Iduna Cyberversicherung"
      heroTitle="Signal Iduna Cyberversicherung"
      heroDescription="Umfassender Cyberschutz für Arztpraxen, MVZ und Kliniken"
      heroFeatures={[
        {
          icon: Shield,
          title: "Bis zu 5 Mio. € Deckung",
          subtitle: "Maximaler Schutz für Ihre Praxis"
        },
        {
          icon: Lock,
          title: "Cybercrime-Schutz",
          subtitle: "Absicherung gegen Hackerangriffe und Datendiebstahl"
        },
        {
          icon: Users,
          title: "24/7 Assistance",
          subtitle: "Rund-um-die-Uhr Notfallhilfe"
        }
      ]}
      alertTitle="Signal Iduna Cyberversicherung"
      alertDescription="Signal Iduna bietet speziell für Arztpraxen entwickelte Cyberversicherungslösungen mit besonderem Fokus auf Datenschutz und IT-Sicherheit im Gesundheitswesen."
      coverageAreas={[
        {
          icon: Shield,
          title: "Cyber-Eigenschäden",
          items: [
            "Datenwiederherstellung nach Cyberangriffen",
            "IT-Forensik und Schadensanalyse",
            "Systemwiederherstellung",
            "Betriebsunterbrechungsschäden"
          ]
        },
        {
          icon: Lock,
          title: "Cyber-Drittschäden",
          items: [
            "Haftpflichtansprüche bei Datenschutzverletzungen",
            "Kosten für Patientenbenachrichtigungen",
            "Rechtsverteidigungskosten",
            "Cyber-Erpressungsschäden"
          ]
        },
        {
          icon: AlertTriangle,
          title: "Notfall-Services",
          items: [
            "24/7 Cyber-Notfall-Hotline",
            "IT-Forensik-Experten",
            "Krisenmanagement",
            "PR-Unterstützung"
          ]
        }
      ]}
      targetGroups={[
        {
          icon: Stethoscope,
          title: "Hausarztpraxen",
          description: "Optimal für Allgemeinmediziner mit digitaler Praxisverwaltung und elektronischer Patientenakte.",
          benefits: [
            "Umfassender Schutz sensibler Patientendaten",
            "Absicherung der Praxissoftware",
            "Betriebsunterbrechungsschutz"
          ],
          recommendation: "Empfohlene Deckungssumme: 1-2 Mio. €"
        },
        {
          icon: Building2,
          title: "Fachärzte",
          description: "Speziell zugeschnitten für Facharztpraxen mit umfangreicher digitaler Diagnostik.",
          benefits: [
            "Schutz medizinischer Bilddaten",
            "Absicherung diagnostischer Systeme",
            "Erweiterte IT-Forensik"
          ],
          recommendation: "Empfohlene Deckungssumme: 2-3 Mio. €"
        },
        {
          icon: Hospital,
          title: "MVZ & Kliniken",
          description: "Umfassende Lösungen für größere medizinische Einrichtungen mit komplexer IT-Infrastruktur.",
          benefits: [
            "Maximale Deckungssummen bis 5 Mio. €",
            "Schutz vernetzter Systeme",
            "Krisenmanagement-Unterstützung"
          ],
          recommendation: "Empfohlene Deckungssumme: 3-5 Mio. €"
        }
      ]}
      insuranceConditions={[
        {
          icon: CheckCircle,
          title: "Versicherungssumme",
          description: "Flexible Deckungssummen von 500.000 € bis 5 Mio. € je nach Praxisgröße und Bedarf"
        },
        {
          icon: Shield,
          title: "Selbstbehalt",
          description: "Wahlweise 0 €, 500 € oder 1.000 € Selbstbehalt - niedrigere Selbstbehalte für besseren Schutz"
        },
        {
          icon: FileText,
          title: "Wartezeit",
          description: "Keine Wartezeit - Sofortschutz ab Vertragsbeginn für alle versicherten Risiken"
        },
        {
          icon: AlertTriangle,
          title: "Nachhaftung",
          description: "12 Monate Nachhaftung bei Vertragsbeendigung für bereits eingetretene, aber noch nicht gemeldete Schäden"
        },
        {
          icon: Lock,
          title: "Mindest-IT-Sicherheit",
          description: "Aktuelle Antivirensoftware, Firewall, regelmäßige Updates und Backups erforderlich"
        },
        {
          icon: Users,
          title: "Assistance-Leistungen",
          description: "24/7 Notfall-Hotline, IT-Forensik-Support und Krisenmanagement im Schadensfall inklusive"
        }
      ]}
      faqs={[
        {
          question: "Welche Deckungssumme ist für meine Praxis empfehlenswert?",
          answer: "Für Einzelpraxen empfehlen wir mindestens 1-2 Mio. €, für größere Praxen oder MVZ 3-5 Mio. €. Die genaue Höhe hängt von der Anzahl der Patientendaten, der IT-Infrastruktur und dem Umsatz ab."
        },
        {
          question: "Sind Ransomware-Erpressungen mitversichert?",
          answer: "Ja, Signal Iduna deckt Cyber-Erpressungen ab, einschließlich gezahlter Lösegelder (nach vorheriger Abstimmung), IT-Forensik und Verhandlungskosten."
        },
        {
          question: "Greift die Versicherung auch bei Mitarbeiterfehlern?",
          answer: "Ja, auch fahrlässiges Verhalten von Mitarbeitern (z.B. Phishing-Opfer) ist versichert. Nur grob fahrlässige oder vorsätzliche Handlungen sind ausgeschlossen."
        },
        {
          question: "Wie schnell erhalte ich Hilfe im Schadensfall?",
          answer: "Die 24/7 Notfall-Hotline steht Ihnen rund um die Uhr zur Verfügung. IT-Forensik-Experten werden bei akuten Vorfällen innerhalb von 4 Stunden vermittelt."
        },
        {
          question: "Welche IT-Sicherheitsmaßnahmen sind Voraussetzung?",
          answer: "Erforderlich sind: aktuelle Antivirensoftware, Firewall, regelmäßige Updates, verschlüsselte Backups und sichere Passwörter. Eine genaue Checkliste erhalten Sie bei Vertragsabschluss."
        },
        {
          question: "Werden auch Bußgelder bei DSGVO-Verstößen übernommen?",
          answer: "Ja, soweit versicherbar übernimmt Signal Iduna auch behördlich verhängte Bußgelder wegen Datenschutzverstößen, sofern diese nicht vorsätzlich herbeigeführt wurden."
        }
      ]}
      documents={[
        {
          title: "Signal Iduna Produktinformation Cyber",
          type: "PDF",
          url: "/erstinformation.pdf"
        },
        {
          title: "Versicherungsbedingungen Cyberversicherung",
          type: "PDF",
          url: "/erstinformation.pdf"
        },
        {
          title: "Antrag Cyberversicherung",
          type: "PDF",
          url: "/erstinformation.pdf"
        }
      ]}
      caseStudies={[
        {
          title: "Ransomware-Angriff auf Gemeinschaftspraxis München",
          description: "Locky-Verschlüsselung legte Praxissystem über Nacht lahm. 450 Patientendaten betroffen, Betrieb für 5 Tage eingestellt.",
          outcome: "Signal Iduna 24/7-Hotline koordinierte IT-Forensik, Datenwiederherstellung aus Backup. Versicherung übernahm 38.200 € (Forensik, Recovery, Umsatzausfall, Patientenbenachrichtigung).",
          damage: "38.200 €"
        },
        {
          title: "DSGVO-Verstoß durch unverschlüsselte E-Mail",
          description: "Mitarbeiter versendete versehentlich 120 Patientenakten unverschlüsselt. Datenschutzbehörde verhängte Bußgeld.",
          outcome: "Signal Iduna stellte Rechtsanwalt, koordinierte Behördenmeldung. Bußgeld von 12.000 € auf 4.500 € reduziert. Versicherung übernahm Bußgeld + 5.800 € Anwaltskosten.",
          damage: "10.300 €"
        },
        {
          title: "Phishing-Angriff auf Zahnarztpraxis",
          description: "Gefälschte Telekom-E-Mail führte zu Zugangsdaten-Diebstahl. Hacker luden Röntgendaten ab.",
          outcome: "IT-Forensik identifizierte Sicherheitslücke, Signal Iduna finanzierte neue Security-Software. Versicherung zahlte 16.700 € (Forensik, Software, Patienteninformation).",
          damage: "16.700 €"
        }
      ]}
    />
  );
};

export default SignalIdunaTarif;
